module.exports = __webpack_public_path__ + "0b2786b7ac5bad3f47319e25521c604d.svg";